(function() {
    'use strict';

    angular
        .module('tmgApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
